import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Accordion } from 'react-bootstrap'
import Style from './AddComent.module.css'
import Input from '../Input/Input'
import { useForm } from 'react-hook-form'
import { faCommentDots } from '@fortawesome/free-regular-svg-icons'
import Button from '../Button/Button'
import CommentList from '../CommentList/CommentList'
import { AddcomentAPI } from '../../Api/ClientServices'
import { errorToast, succToast } from '../../Utils/Toast/Toast'

const AddComent = ({title}) => {
    
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data) =>{
        let info={
            course_id:window.location.pathname.split('/')[3],
            message:data.comment
        }
        AddcomentAPI(info,(succ)=>{
            if(succ.status===1){
                succToast(succ.message)
                setTimeout(() => {
                    window.location.reload()
                }, 1000);
            }
            else{
                errorToast(succ.message)
            }
        })
    }
    return (
        <Accordion  className={Style.AcaredonHolder}>
        <Accordion.Item  eventKey='0' className='w-100'>
            <Accordion.Header  className={Style.AccordionHeader}><h4 className={Style.TitleHolder}><div>{title}</div> <p className={Style.arrowHolder}><FontAwesomeIcon icon={faArrowDown}/></p></h4></Accordion.Header>
            <Accordion.Body>
                <form onSubmit={handleSubmit(onSubmit)} className={Style.ModalFormHolder}>
                    <h3 className='text-end'><FontAwesomeIcon icon={faCommentDots}/> نظر شما</h3>
                    <Input 
                    type='textarea'
                    {...register("comment", { required: true })}
                    inputtype={errors.comment ? "validTextArea" : "textArea"}
                    placeholder={'متن...'}
                    /> 
                    <Button Value={'ثبت نظر'} ClassBtn="confirmBtn"/>
                </form>
                <CommentList />
            </Accordion.Body>
        </Accordion.Item>

    </Accordion>
    )
}

export default AddComent
